module.exports = __webpack_public_path__ + "h5/img/handsel_0.f1b4f6dc.jpg";